<template>
  <div id="app">
    <HeaderComponent />
    <router-view />
    <FooterComponent />
  </div>
</template>
<script>
import HeaderComponent from './components/Header.vue';
import FooterComponent from './components/Footer.vue';

export default {
  components: {
    HeaderComponent,
    FooterComponent,
  },
};
</script>
<style>
/* @media screen and (max-height: 600px) {
  .main-section {
    height: calc(160dvh - 6rem);
  }
}

@media screen and (min-height: 600px) {
  .main-section {
    height: calc(100dvh - 6rem);
  }
} */

.main-section {
  min-height: calc(100svh - 6rem);
  /* iOS/Android safe viewport */
  min-height: calc(100dvh - 6rem);
  /* modern browsers */
  /* padding-block: 2rem; */
  /* top & bottom padding */

}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
